export default "__VITE_ASSET__nf2gyivf__"